<template>
  <div :class="componentClassName">
    <a-page-heading>
      <span>アウトバウンド</span>
      <a-button
        id="reloadData"
        class="t-outbound-list__refresh-button"
        variant="round"
        size="medium"
        label="更新"
        color="primary"
        :inline="true"
        :nowrap="true"
        @click="getOutboundList()"
      />
    </a-page-heading>
    <a-select-field
      v-if="companyID === POINT && authInfo !== 'soOperator' && companyIDList.length !== 0"
      id="selectCompanyID"
      v-model="selectedCompanyID"
      :options="companyIDList"
      :searchable="true"
    />
    <m-section>
      <m-action-card title="" icon="">
        <m-data-table
          v-if="tableDataLoaded"
          id="table-area"
          ref="dataTable"
          :empty-text="dataTableEmptyText"
          :fit="true"
          :data="tableData"
          :is-outbound-list="true"
        >
          <a-data-table-column :width="47" prop="no" label="No" align="left" />
          <a-data-table-column :min-width="180" prop="id" label="リスト名" align="left">
            <template #default="scope">
              <a-text v-if="scope.row.registered" size="small">{{ scope.row.listName }} </a-text>
              <a-text v-if="!scope.row.registered" size="small">{{ '未登録' }} </a-text>
            </template>
          </a-data-table-column>
          <a-data-table-column :min-width="90" prop="timestamp" label="登録日時" align="left">
            <template #default="scope">
              <a-text v-if="scope.row.registered && scope.row.updateDate" size="small">
                <span>{{ scope.row.updateDate.split(' ')[0] }}</span>
                <br />
                <span>{{ scope.row.updateDate.split(' ')[1] }}</span>
              </a-text>
              <a-text v-else size="small">-</a-text>
            </template>
          </a-data-table-column>
          <a-data-table-column
            class="t-outbound-list__tooltip"
            :min-width="90"
            prop="implementedCount"
            label="架電実施数"
            align="left"
          >
            <template #default="scope">
              <a-text v-if="scope.row.registered" size="small">
                <span>{{ scope.row.implementedCount }} 件終了</span>
                <br />
                <span>/{{ scope.row.currentTotalCount }} 件中</span>
              </a-text>
              <a-text v-if="!scope.row.registered" size="small">-</a-text>
            </template>
            <template #icon>
              <a-button
                :data-tooltip="'現在の繰り返しで架電した件数です。'"
                variant="icon"
                color="white"
                icon="info"
                icon-color="orange"
                :inline="true"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column
            class="t-outbound-list__tooltip"
            :min-width="90"
            prop="progressInfo"
            label="完了数"
            align="left"
          >
            <template #default="scope">
              <a-text v-if="scope.row.registered" size="small">
                <span>{{ scope.row.progressInfo }} 件完了</span>
                <br />
                <span>/{{ scope.row.total }} 件中</span>
              </a-text>
              <a-text v-if="!scope.row.registered" size="small">-</a-text>
            </template>
            <template #icon>
              <a-button
                :data-tooltip="'架電し完了した件数です。'"
                variant="icon"
                color="white"
                icon="info"
                icon-color="orange"
                :inline="true"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column :min-width="90" prop="repeatCount" label="繰り返し" align="left">
            <template #default="scope">
              <a-text v-if="scope.row.registered" size="small">
                {{ scope.row.repeatCount }} 回目/{{ scope.row.repeatLimit }} 回中
              </a-text>
              <a-text v-if="!scope.row.registered" size="small">-</a-text>
            </template>
          </a-data-table-column>
          <a-data-table-column
            class="t-outbound-list__col-status"
            :min-width="80"
            prop="status"
            label="ステータス"
            align="left"
          >
            <template #default="scope">
              <a-text v-if="scope.row.registered" size="small">{{ scope.row.status }}</a-text>
              <a-text v-if="!scope.row.registered" size="small">-</a-text>
            </template>
          </a-data-table-column>
          <a-data-table-column class="t-outbound-list__no-striped" :width="10" type="action" label="" align="center" />
          <a-data-table-column class="t-outbound-list__no-striped" :width="70" type="action" label="" align="center">
            <template #default="scope">
              <a-button
                v-if="scope.row.registered && !scope.row.isAllImplemented"
                v-show="!isAllowOtherCompany"
                :id="scope.row.id + '_call'"
                variant="round"
                size="small"
                label="架電"
                :color="!scope.row.registered || !scope.row.startFlag ? 'grey' : 'primary'"
                icon="outbound"
                icon-color="white"
                :inline="true"
                :nowrap="true"
                :disabled="!scope.row.registered || !scope.row.startFlag"
                @click="handleGoToOutboundDetailPage(scope.row)"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column class="t-outbound-list__no-striped" :width="70" type="action" label="" align="center">
            <template #default="scope">
              <a-button
                v-if="scope.row.registered && !scope.row.isAllImplemented && !scope.row.startFlag"
                v-show="isAllowAccess"
                :id="scope.row.id + '_start'"
                variant="outlined-round-small"
                size="small"
                label="開始"
                color="primary"
                icon="audio-play"
                icon-color="orange"
                :inline="true"
                :nowrap="true"
                @click="handleStartButtonClick(scope.row, true)"
              />
              <a-button
                v-if="scope.row.registered && !scope.row.isAllImplemented && scope.row.startFlag"
                v-show="isAllowAccess"
                :id="scope.row.id + '_stop'"
                variant="outlined-round-small"
                size="small"
                label="停止"
                color="primary"
                icon="audio-stop"
                icon-color="orange"
                :inline="true"
                @click="handleStopButtonClick(scope.row)"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column class="t-outbound-list__no-striped" :width="60" type="action" label="" align="center">
            <template #default="scope">
              <a-button
                v-if="scope.row.registered && !scope.row.isAllImplemented"
                v-show="isAllowAccess || isAllowOtherCompanyUnlock"
                :id="scope.row.id + '_unlock'"
                variant="round"
                size="small"
                label="解除"
                color="grey"
                :inline="true"
                :disabled="!scope.row.registered || scope.row.startFlag"
                @click="handleUnlockAllPhoneNumber(scope.row)"
              />
            </template>
          </a-data-table-column>
          <!-- scrollbarがない場合、ダウンロード・アップロードボタンはアイコンとテキストで表示される -->
          <a-data-table-column
            v-if="!hasHorizontalScrollbar"
            class="t-outbound-list__no-striped"
            :width="110"
            type="action"
            label=""
            align="center"
          >
            <template #default="scope">
              <a-button
                v-if="!scope.row.registered"
                v-show="isAllowAccess"
                :id="scope.row.id + '_upload'"
                variant="round"
                size="small"
                label="アップロード"
                color="grey"
                icon="upload"
                icon-color="black"
                :inline="true"
                :disabled="scope.row.startFlag"
                @click="handleUploadButtonClick(scope.row)"
              />
              <a-button
                v-if="scope.row.registered"
                v-show="isAllowAccess || isAllowOtherCompanyDownload"
                :id="scope.row.id + '_download'"
                variant="round"
                size="small"
                label="ダウンロード"
                color="grey"
                icon="download"
                icon-color="black"
                :inline="true"
                :loading="loadings[scope.row.id]"
                :disabled="scope.row.startFlag && !scope.row.isAllImplemented"
                @click="handleDownload(scope.row)"
              />
            </template>
          </a-data-table-column>
          <!-- scrollbarがある場合、ダウンロード・アップロードボタンはアイコンのみで表示される -->
          <a-data-table-column
            v-if="hasHorizontalScrollbar"
            class="t-outbound-list__no-striped"
            type="action"
            label=""
            align="center"
          >
            <template #default="scope">
              <a-button
                v-if="!scope.row.registered"
                v-show="isAllowAccess"
                :id="scope.row.id + '_upload'"
                variant="icon"
                size="small"
                label="アップロード"
                color="grey"
                icon="upload"
                icon-color="black"
                :inline="true"
                :disabled="scope.row.startFlag"
                @click="handleUploadButtonClick(scope.row)"
              />
              <a-button
                v-if="scope.row.registered"
                v-show="isAllowAccess || isAllowOtherCompanyDownload"
                :id="scope.row.id + '_download'"
                variant="icon"
                size="small"
                label="ダウンロード"
                color="grey"
                icon="download"
                icon-color="black"
                :inline="true"
                :loading="loadings[scope.row.id]"
                :disabled="scope.row.startFlag && !scope.row.isAllImplemented"
                @click="handleDownload(scope.row)"
              />
            </template>
          </a-data-table-column>
          <!-- scrollbarがない場合、削除ボタンはアイコンとテキストで表示される -->
          <a-data-table-column
            v-if="!hasHorizontalScrollbar"
            class="t-outbound-list__no-striped"
            :width="85"
            type="action"
            label=""
            align="center"
          >
            <template #default="scope">
              <a-button
                v-if="scope.row.registered"
                v-show="isAllowAccess"
                :id="scope.row.id + '_delete'"
                variant="round"
                size="small"
                label="削除"
                color="grey"
                icon="trash"
                icon-color="black"
                :inline="true"
                :disabled="(!scope.row.registered || scope.row.startFlag) && !scope.row.isAllImplemented"
                @click="handleButtonRemoveOutboundList(scope.row)"
              />
            </template>
          </a-data-table-column>
          <!-- scrollbarがある場合、削除ボタンはアイコンのみで表示される -->
          <a-data-table-column
            v-if="hasHorizontalScrollbar"
            class="t-outbound-list__no-striped"
            type="action"
            label=""
            align="center"
          >
            <template #default="scope">
              <a-button
                v-if="scope.row.registered && hasHorizontalScrollbar"
                :id="scope.row.id + '_delete'"
                variant="icon"
                color="grey"
                icon="trash"
                :icon-color="
                  (!scope.row.registered || scope.row.startFlag) && !scope.row.isAllImplemented ? 'grey' : 'black'
                "
                :inline="true"
                :disabled="(!scope.row.registered || scope.row.startFlag) && !scope.row.isAllImplemented"
                @click="handleButtonRemoveOutboundList(scope.row)"
              />
            </template>
          </a-data-table-column>
        </m-data-table>
      </m-action-card>
    </m-section>

    <teleport to="body"
      ><o-modal
        id="outbound-list-upload-modal"
        v-model:visible="outboundListUploadDialogVisible"
        class="t-outbound-list__o-modal-outbound-list-dialog-upload"
        footer-variant="dialog"
        :footer-shadow="true"
        :close-on-click-modal="false"
        z-index="9998"
      >
        <template #title>No{{ currentNo }}　電話番号リスト登録</template>
        <a-text size="small">リスト名を入力し、アップロードボタンよりCSVファイルをアップロードしてください。</a-text>
        <a-text size="small">CSVファイルのテンプレートをダウンロードボタンよりダウンロードできます。</a-text>
        <a-text size="small">※リストに登録できる件数は最大1000件です。</a-text>
        <a-text size="small">※架電番号,架電先名称は必須です。</a-text>
        <a-text size="small">※文字コードはUTF-8で設定してください。</a-text>
        <m-form-input label="リスト名">
          <a-text-field
            id="outbound_setting_name"
            v-model="uploadData.listName"
            type="text"
            placeholder="営業問合せ"
            :maxlength="20"
          />
        </m-form-input>
        <m-form-input align="left" label="ファイル">
          <a-upload-field
            v-if="outboundListUploadDialogVisible"
            v-model="currentUploadFile.file"
            class="t-outbound-list__uploading-file__form-upload"
            accept=".csv,.CSV"
            :disabled="isUploading"
            @change="handleFileUploadChange"
          />
        </m-form-input>
        <m-form-input align="left" label="CSVファイルのテンプレートをダウンロード">
          <a-button
            id="outbound-list-template"
            class="t-outbound-list__download-template-file"
            variant="fill"
            color="primary"
            size="small"
            label="ダウンロード"
            icon="download"
            icon-color="white"
            :disabled="isUploading"
            @click="handleDownloadCsvTemplate()"
          />
        </m-form-input>
        <m-form-input class="t-outbound-list__csv-form-input" label="発信番号">
          <a-select-field
            id="-outgoingNumberOption"
            v-model="uploadData.phone"
            class="t-outbound-list__uploading-file__select-number"
            :options="phoneList"
          />
        </m-form-input>
        <m-form-input label="繰り返し回数">
          <a-select-field
            id="repeatLimit"
            v-model="uploadData.repeatLimit"
            class="t-outbound-list__uploading-file__repeat-limit"
            :options="repeatLimit"
            placeholder="選択"
          />
        </m-form-input>
        <template #footer>
          <a-button
            id="outbound_button_ok"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            :disabled="isUploading"
            @click="handleUpload"
          />
          <a-button
            id="outbound_button_cancel"
            variant="outlined"
            color="primary"
            label="キャンセル"
            size="small"
            :disabled="isUploading"
            @click="handleCancelUploadDialog"
          />
        </template>
      </o-modal>
    </teleport>
    <teleport to="body">
      <o-modal
        id="outboundList_uploadResultModal"
        v-model:visible="uploadResultModalVisible"
        class="o-modal-outbound-list-dialog-upload"
        footer-variant="dialog"
        width="350px"
        :footer-shadow="true"
        :close-on-click-modal="false"
      >
        <template #title>No{{ currentNo }}</template>
        <a-text :center="true">{{ uploadResultContent }}</a-text>
        <template #footer>
          <a-button
            id="outbound_result_button_ok"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            @click="handleCloseUploadResult"
          />
        </template>
      </o-modal>
    </teleport>

    <teleport to="body">
      <o-modal
        id="outboundList_infoModal"
        v-model:visible="infoModalVisible"
        class="o-modal-info-modal"
        footer-variant="confirmation"
        width="442px"
        z-index="$zindex-modal"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ infoModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span v-html="infoModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button id="modal-ok" variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
        </template>
      </o-modal>

      <o-modal
        id="outboundList_areLockedModal"
        v-model:visible="notifyAllNumberAreLockedModalVisible"
        class="o-modal-notify-all-number-locked-modal"
        footer-variant="confirmation"
        width="442px"
        z-index="$zindex-modal"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title> Info </template>
        <a-text>
          <!-- eslint-disable -->
          <span v-html="notifyAllPhoneAreLockedContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button
            id="notify-lock-modal-ok"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            @click="closeNoifyAllNumberLockedModal"
          />
        </template>
      </o-modal>
    </teleport>
    <teleport to="body">
      <o-modal
        id="outboundList_removeModal"
        v-model:visible="removeOutboundListDialogVisible"
        class="o-modal-remove-outbound-list-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
      >
        <template #title> 電話番号リスト削除 </template>
        <a-text :center="true">
          <!-- eslint-disable -->
          <a-text :center="true"> {{ 'No' + currentNo + '  ' + currentListName }}</a-text>
          <a-text :center="true">{{ removeOutboundListDialogMessageContent }}</a-text>
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button
            id="removeOutboundListCancelBtn"
            variant="outlined"
            color="primary"
            label="いいえ"
            size="small"
            :disabled="isDeleting"
            @click="handleCancelRemoveOutboundList"
          />
          <a-button
            id="removeOutboundListDialogOKBtn"
            variant="block"
            color="primary"
            label="はい"
            size="small"
            :disabled="isDeleting"
            @click="handleConfirmRemoveOutboundList"
          />
        </template>
      </o-modal>
    </teleport>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MActionCard from '@/components/molecules/action-card';
import AButton from '@/components/atoms/button';
import AText from '@/components/atoms/text';
import MSection from '@/components/molecules/section';
import MDataTable from '@/components/molecules/data-table';
import ADataTableColumn from '@/components/atoms/data-table-column';
import OModal from '@/components/organisms/modal';
import AUploadField from '@/components/atoms/upload-field';
//import ASelectField from '@/components/atoms/select-field';

import { customRequest } from '@/common/customRequest.js';
import { customValidate } from '@/common/customValidate.js';
import { messageContent } from '@/common/messageContent.js';
import { showMsgBoxMixin } from '@/common/showMsgBox.js';

import { POINT } from '@/libs/constants';
import { utils } from '@/common/utils.js';
import { PERMISSIONS_FRONTEND } from '@/libs/constants';
import dayjs from 'dayjs';
import { DEFAULT_TIMEZONE } from '@/libs/constants';
import languageEncoding from 'detect-file-encoding-and-language';

const UNSELECTED = 'unselected';

export default {
  name: 't-number-mgmt-general',
  components: {
    APageHeading,
    MSection,
    MActionCard,
    AButton,
    AText,
    MDataTable,
    ADataTableColumn,
    AUploadField,
    //ASelectField,
    OModal,
  },
  mixins: [customRequest, customValidate, showMsgBoxMixin],
  props: {
    class: {
      type: String,
      default: '',
    },
    companyID: {
      type: String,
      default: '',
    },
    clientName: {
      type: String,
      default: '',
    },
    phoneNumber: {
      type: String,
      default: '',
    },
    userID: {
      type: String,
      default: '',
      required: true,
    },
  },
  data() {
    return {
      tableData: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
      tableDataLoaded: false,
      isLoading: false,
      dataTableEmptyText: '',

      //upload data
      uploadData: {
        id: '',
        listName: '',
        repeatLimit: 1,
        phone: '',
        outboundCallList: [],
      },
      //upload dialog
      outboundListUploadDialogVisible: false,

      //選択されるリスト
      currentNo: '',
      currentListName: '',
      currentOutboundListID: '',

      //upload result dialog
      uploadResultModalVisible: false,
      uploadResultContent: '',
      //アップロードファイル
      currentUploadFile: {
        file: null,
        binary: null,
        size: 0,
        name: '',
      },
      phone: '',
      phoneList: [{ label: '発信元番号選択', value: UNSELECTED }],
      //previousSelectedTelNumber: UNSELECTED,

      //info modal
      infoModalTitle: '',
      infoModalContent: '',
      infoModalVisible: false,

      //削除確認モーダル
      removeOutboundListDialogVisible: false,
      removeOutboundListDialogMessageContent: '削除してよろしいですか',

      //number locked confirm
      notifyAllNumberAreLockedModalVisible: false,

      //繰り返す
      repeatLimit: [
        { value: 1, label: '1' },
        { value: 2, label: '2' },
        { value: 3, label: '3' },
      ],

      companyIDList: [],
      selectedCompanyID: '',
      POINT,
      isShowUnlockButton: false,
      tableMinWidth: 1040,
      hasHorizontalScrollbar: false,
      loadings: {},

      //ロック状態エラーメッセージ
      notifyAllPhoneAreLockedContent: messageContent.notifyAllPhoneAreLocked,

      statuses: { started: '開始中', stopped: '停止中', completed: '完了' },
      isUploading: false,
      isDeleting: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-outbound-list');
      return `${baseClassName} ${this.class}`.trim();
    },
    authInfo() {
      return this.$store.state.user.authInfo;
    },
    currentPhoneNumber() {
      return this.$store.state.user.phoneNumber;
    },
    currentCompanyID() {
      return this.$store.state.user.companyID;
    },
    isAllowAccess() {
      if (this.companyID === this.selectedCompanyID) {
        return ['supervisor', 'manager'].includes(this.authInfo);
      } else {
        return false;
      }
    },
    // 他の契約ID用
    isAllowOtherCompany() {
      if (this.companyID !== this.selectedCompanyID) {
        return true;
      }
      return false;
    },
    // 他の契約IDのダウンロードボタン用
    isAllowOtherCompanyDownload() {
      if (this.companyID !== this.selectedCompanyID && ['supervisor', 'manager'].includes(this.authInfo)) {
        return true;
      }
      return false;
    },
    isAllowOtherCompanyUnlock() {
      if (this.companyID !== this.selectedCompanyID && ['supervisor', 'manager', 'operator'].includes(this.authInfo)) {
        return true;
      }
      return false;
    },
  },
  watch: {
    selectedCompanyID: async function (newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        await this.getOutboundList();
      } else {
        this.selectedCompanyID = oldValue;
      }
    },
    hasHorizontalScrollbar: function (newValue, oldValue) {
      if (this.tableDataLoaded) {
        this.tableDataLoaded = false;
        const self = this;
        setInterval(() => (self.tableDataLoaded = true), 100);
      }
    },
    tableDataLoaded: function (newValue, oldValue) {
      const self = this;
      this.$nextTick(() => {
        const tableArea = document.getElementById('table-area');
        if (tableArea) {
          self.hasHorizontalScrollbar = tableArea.clientWidth < self.tableMinWidth;
        }
      });
    },
  },
  async created() {
    if (PERMISSIONS_FRONTEND['OutboundList']) {
      if (!PERMISSIONS_FRONTEND['OutboundList'][this.authInfo]) {
        this.$router.push({ path: '/permission-denied' });
        return;
      }
    }
    if (utils.chkTrialCompanyID(this.companyID)) {
      this.$router.push({
        path: '/permission-denied',
        query: { type: 'trial', page: 'outbound' },
      });
    }

    if (this.companyID === POINT && this.authInfo !== 'soOperator') {
      await this.fetchCompanyIDListHandler();
      this.selectedCompanyID = this.companyID;
    }
    this.selectedCompanyID = this.companyID;

    await this.handleFetchAvailableTelNumbers();

    this.getOutboundList();
  },
  mounted() {
    const self = this;
    window.onresize = function (event) {
      const tableArea = document.getElementById('table-area');
      if (tableArea) {
        self.hasHorizontalScrollbar = tableArea.clientWidth < self.tableMinWidth;
      }
    };
  },
  methods: {
    // lineNoが設定される場合、lineNo行のデータのみで更新する
    getOutboundList(lineNo) {
      if (!lineNo) this.tableData = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}];
      this.postRequest('/outbound/getOutboundList', { companyID: this.selectedCompanyID })
        .then(async res => {
          if (res.status === 'failed') throw 'Get list failed.';
          const data = res.data;
          const outboundListDocumentRuleName = 'outboundCallList';
          for (let i = 0; i < data.length; i++) {
            const key = Object.keys(data[i])[0];
            const no = parseInt(key.split(outboundListDocumentRuleName)[1]);
            if (lineNo && lineNo !== no) continue;
            const outboundListDocumentName = outboundListDocumentRuleName + no;
            const outboundCallList = data[i][outboundListDocumentName].outboundCallList || {};
            const repeatCount = data[i][outboundListDocumentName].repeatCount;
            const total = Object.keys(outboundCallList).length;
            let implementedCount = 0; // 現在の切り返し回の架電実施済数
            let currentTotalCount = 0; // 現在の切り返し回の架電実施数
            let nameStatusCompletedCount = 0; // nameStatusはcompleted件数
            for (const j in outboundCallList) {
              const item = outboundCallList[j];
              if (item.dialCount === repeatCount || (item.dialCount < repeatCount && item.status !== 'completed')) {
                currentTotalCount++;
                if (item.nameStatus && item.status && item.nameStatus !== 'locked') implementedCount++;
              }
              if (item.nameStatus === 'completed') nameStatusCompletedCount++;
            }
            // ステータスカラムに「完了」かどうか判断する
            const isAllImplemented =
              data[i][outboundListDocumentName].progressInfo === total ||
              (repeatCount === data[i][outboundListDocumentName].repeatLimit && nameStatusCompletedCount === total);
            // const isAllImplemented = data[i][outboundListDocumentName].progressInfo === total;
            if (isAllImplemented && data[i][outboundListDocumentName].startFlag) {
              await this.handleUpdateOutboundListStatus(outboundListDocumentName, false);
            }
            const item = {
              no: no,
              id: outboundListDocumentName,
              listName: data[i][outboundListDocumentName].listName ? data[i][outboundListDocumentName].listName : '',
              listUser: data[i][outboundListDocumentName].listUser,
              outboundCallList: outboundCallList,
              repeatLimit: data[i][outboundListDocumentName].repeatLimit,
              repeatCount: data[i][outboundListDocumentName].repeatCount,
              phone: data[i][outboundListDocumentName].phone,
              total: total,
              progressInfo: data[i][outboundListDocumentName].progressInfo,
              updateDate: data[i][outboundListDocumentName].updateDate,
              startFlag: data[i][outboundListDocumentName].startFlag,
              dialCount: data[i][outboundListDocumentName].dialCount,
              registered: total > 0 ? true : false,
              implementedCount,
              currentTotalCount,
              isAllImplemented,
              status: isAllImplemented
                ? this.statuses.completed
                : data[i][outboundListDocumentName].startFlag
                ? this.statuses.started
                : this.statuses.stopped,
              isGrey: total > 0 && (isAllImplemented || !data[i][outboundListDocumentName].startFlag), // 背景はグレー判定
            };

            this.tableData[no - 1] = item;
          }

          for (let i = 0; i < 10; i++) {
            if (Object.keys(this.tableData[i]).length === 0) {
              const no = i + 1;
              if (lineNo && lineNo !== no) continue;
              const outboundListDocumentName = outboundListDocumentRuleName + no;
              this.tableData[i] = {
                no: no,
                id: outboundListDocumentName,
                listname: '',
                outboundCallList: {},
                repeatLimit: 1,
                repeatCount: 1,
                listUser: '',
                phone: '',
                total: 0,
                progressInfo: 0,
                updateDate: '',
                startFlag: false,
                registered: false,
                implementedCount: 0,
                currentTotalCount: 0,
                isAllImplemented: false,
                status: '-',
                isGrey: false,
              };
            }
          }
          // 検索結果が0件の場合
          if (this.tableData.length === 0) {
            this.dataTableEmptyText = '検索に一致する情報が見つかりませんでした';
          }
          this.tableDataLoaded = true;
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('電話番号情報の取得'));
        });
    },
    async handleGoToOutboundDetailPage(row) {
      const getCallListDetail = await this.postRequest('/outbound/getCallListData', {
        id: row.id,
        nameStatusConfirm: true,
      })
        .then(data => {
          if (data.status === 'success') return data.data;
          return null;
        })
        .catch(() => {
          return null;
        });
      if (!getCallListDetail) return this.showErrorModal(messageContent.requireTry('架電'));

      if (!getCallListDetail.allowCall) {
        return this.showErrorModal(messageContent.notifyDeletedList);
      }
      if (
        getCallListDetail.progressInfo < getCallListDetail.total &&
        getCallListDetail.repeatCount <= getCallListDetail.repeatLimit &&
        !getCallListDetail.processCallIndex
      ) {
        return this.showNotifyAllNumberAreLocked();
      }
      return this.$router.push({
        path: '/outbound/outboundCall',
        query: { companyID: this.companyID, id: row.id },
      });
    },
    handleStartButtonClick(row) {
      this.changeToOutboundStartStatus(row);
    },
    handleStopButtonClick(row) {
      this.changeToOutboundStopStatus(row);
    },
    async handleUploadButtonClick(row) {
      const getCallListDetail = await this.postRequest('/outbound/getCallListData', {
        id: row.id,
        nameStatusConfirm: true,
      })
        .then(data => {
          if (data.status === 'success') return data.data;
          return null;
        })
        .catch(() => {
          return null;
        });
      if (getCallListDetail && getCallListDetail.startFlag) {
        this.showErrorModal(messageContent.notifyOutboundDataHasChanged); //開始したのはアップロードできません
        return;
      }
      this.uploadResultContent = '';
      this.currentNo = '';
      this.clearUploadData();
      this.clearInputCsvFile();
      this.uploadData.id = row.id;
      this.uploadData.listName = row.listName;
      this.uploadData.repeatLimit = row.repeatLimit;
      this.uploadData.phone = this.phoneList[0].value;
      if (row.phone) {
        const hasPhone = this.phoneList.find(phone => phone.value === row.phone);
        if (hasPhone) this.uploadData.phone = row.phone;
      }
      this.outboundListUploadDialogVisible = true;
      this.currentNo = row.no;
    },
    handleCancelUploadDialog() {
      this.clearUploadData();
      this.clearInputCsvFile();
      this.outboundListUploadDialogVisible = false;
    },
    handleUpload() {
      this.isUploading = true;
      const validateResult = this.validateUploadCsvData();
      if (validateResult) {
        this.isUploading = false;
        return this.handleShowUploadResultModal(validateResult, '', this.currentNo);
      }
      const self = this;
      const uploadData = {
        id: this.uploadData.id,
        listName: this.uploadData.listName,
        repeatLimit: this.uploadData.repeatLimit,
        phone: this.uploadData.phone,
        outboundCallList: this.uploadData.outboundCallList,
      };
      return this.postRequest('/outbound/uploadOutboundList', uploadData)
        .then(e => {
          self.isUploading = false;
          if (e.status === 'success') {
            const uploadedRecord = this.uploadData.outboundCallList.length;
            self.handleShowUploadResultModal('', uploadedRecord);
            self.getOutboundList(self.currentNo);
          } else if (e.status === 'updateInfoInvalid') {
            self.handleShowUploadResultModal(messageContent.notifyOutboundDataHasChanged, 0);
          } else if (e.status === 'failed') {
            const errorMsg = e.status.msg ? e.status.msg : messageContent.requireTry('アップロード');
            self.handleShowUploadResultModal(errorMsg, 0);
          } else {
            throw new Error('failed');
          }
          self.handleCancelUploadDialog();
        })
        .catch(() => {
          self.isUploading = false;
          self.outboundListUploadDialogVisible = false;
          self.showErrorModal(messageContent.requireTry('アップロード'));
        });
    },
    async handleFileUploadChange(file) {
      const reader = new FileReader();

      if (file[0]) {
        const targetFile = new File([file[0]], file[0].name, { type: file[0].type });
        const fileInfo = await languageEncoding(targetFile);
        if (targetFile.type.toLowerCase() !== 'text/csv') {
          this.clearInputCsvFile();
          this.handleShowUploadResultModal(messageContent.csvSelectRequired);
          return;
        }
        if (!fileInfo.encoding || fileInfo.encoding.toLowerCase() !== 'utf-8') {
          this.clearInputCsvFile();
          this.handleShowUploadResultModal(messageContent.csvFileEncodingNotUTF8);
          return;
        }
        reader.readAsText(targetFile);
        this.currentUploadFile.size = targetFile.size;
        this.currentUploadFile.name = targetFile.name;
      } else {
        this.clearInputCsvFile();
      }
      const self = this;
      reader.onload = () => {
        self.currentUploadFile.binary = reader.result;
        self.uploadData.outboundCallList = self.csv2array(self.currentUploadFile.binary);
        const validationResult = self.validateCsvData();
        if (validationResult) {
          self.clearInputCsvFile();
          self.handleShowUploadResultModal(validationResult);
        }
      };
      reader.onerror = () => {
        self.clearInputCsvFile();
        self.showErrorModal('CSVアップロード中にエラーが発生しました。時間を空けて再度実行してください。');
      };
    },
    async handleDownload(row) {
      this.loadings[row.id] = true;
      const csvData = await this.postRequest('/outbound/downloadOutboundCsv', {
        id: row.id,
        nameStatusConfirm: true,
        companyID: this.selectedCompanyID || this.companyID,
      })
        .then(data => {
          if (data.status === 'success') return data.data;
          return null;
        })
        .catch(() => {
          return null;
        });

      // CSVデータ取得失敗
      if (!csvData) {
        this.showErrorModal(messageContent.notifyOutboundDataHasChanged);
        this.loadings[row.id] = false;
        return;
      }

      const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
      const blob = new Blob([bom, csvData], { type: 'text/plain' });
      const url = URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      document.body.appendChild(anchor);
      const now = dayjs().tz(DEFAULT_TIMEZONE);
      const year = now.format('YYYY');
      const month = now.format('MM');
      const day = now.format('DD');
      const hour = now.format('HH');
      const min = now.format('mm');
      const sec = now.format('ss');

      const file_name = `${row.listName}_${year}${month}${day}${hour}${min}${sec}`;
      anchor.download = file_name + '.csv';
      anchor.href = url;
      anchor.click();
      anchor.remove();
      URL.revokeObjectURL(url);
      this.loadings[row.id] = false;
    },

    handleDownloadCsvTemplate() {
      const csv = '架電番号,架電先名称\r\n';
      const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
      const blob = new Blob([bom, csv], { type: 'text/plain' });
      const url = URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      document.body.appendChild(anchor);

      const file_name = 'outbound_list_template';
      anchor.download = file_name + '.csv';
      anchor.href = url;
      anchor.click();
      anchor.remove();
      URL.revokeObjectURL(url);
    },
    handleButtonRemoveOutboundList(row) {
      this.currentNo = row.no;
      this.currentListName = row.listName;
      this.currentOutboundListID = row.id;
      this.showRemoveConfirmDialog();
    },
    handleConfirmRemoveOutboundList() {
      this.isDeleting = true;
      this.postRequest('/outbound/deleteOutboundCallList', { id: this.currentOutboundListID })
        .then(data => {
          this.isDeleting = false;
          this.removeOutboundListDialogVisible = false;
          if (data.status === 'success') {
            this.getOutboundList(this.currentNo);
          } else {
            if (data.status === 'updateInfoInvalid') {
              this.showErrorModal(messageContent.notifyOutboundDataHasChanged);
            } else {
              this.showErrorModal(messageContent.requireTry('電話番号リスト削除'));
            }
          }
        })
        .catch(e => {
          this.isDeleting = false;
          this.removeOutboundListDialogVisible = false;
          this.showErrorModal(messageContent.requireTry('電話番号リスト削除'));
        });
    },
    showRemoveConfirmDialog() {
      this.removeOutboundListDialogVisible = true;
    },
    handleCancelRemoveOutboundList() {
      this.removeOutboundListDialogVisible = false;
      this.currentNo = '';
      this.currentOutboundListID = '';
    },
    async changeToOutboundStartStatus(row) {
      const result = await this.handleUpdateOutboundListStatus(row.id, true);
      if (!result) {
        this.getOutboundList(row.no);
      } else {
        if (result === 'updateInfoInvalid') {
          this.showErrorModal(messageContent.notifyOutboundDataHasChanged);
        } else {
          this.showErrorModal(messageContent.requireTry('開始'));
        }
      }
    },
    async changeToOutboundStopStatus(row) {
      const result = await this.handleUpdateOutboundListStatus(row.id, false);
      if (!result) {
        this.getOutboundList(row.no);
      } else {
        if (result === 'updateInfoInvalid') {
          this.showErrorModal(messageContent.notifyOutboundDataHasChanged);
        } else {
          this.showErrorModal(messageContent.requireTry('停止'));
        }
      }
    },
    //changeToListUnregisteredStatus(row) {},
    isRegistered(row) {
      if (row.id !== '') return true;
      return false;
    },
    isStart(row) {
      if (row.status === 'start') return true;
      return false;
    },
    showInfoModal(content) {
      this.infoModalTitle = messageContent.infoModalTitle;
      this.infoModalVisible = true;
      this.infoModalContent = content;
    },
    showErrorModal(message) {
      this.infoModalVisible = true;
      this.infoModalTitle = messageContent.errorModalTitle;
      this.infoModalContent = message;
    },
    handleCloseModal() {
      this.infoModalVisible = false;
      this.infoModalTitle = '';
      this.infoModalContent = '';
    },
    csv2array(csvData) {
      const csvDataArr = csvData.split(/\r?\n/);
      csvDataArr.length > 2 ? csvDataArr.shift() : csvDataArr;
      const resultDataArr = [];
      // 空白行があれば削除
      for (const line of csvDataArr) {
        const column = line.split(',');
        const phoneNumber = column && column.length >= 1 ? column[0] : '';
        const phoneName = column && column.length >= 2 ? column[1] : null;
        const callInfo = {
          phone: phoneNumber,
          name: phoneName,
        };
        if (line.length > 0) {
          resultDataArr.push(callInfo);
        }
      }
      return resultDataArr;
    },
    validateCsvData() {
      const extList = this.currentUploadFile.name.split('.');
      const ext = extList[extList.length - 1].toLowerCase();

      if (ext !== 'csv') return messageContent.requireChoice('CSVファイル');
      if (this.currentUploadFile.size === 0 || this.currentUploadFile.size > 10485760)
        return messageContent.alertUploadfileSizeExceeded(10);
      if (!this.uploadData.outboundCallList) return 'ファイルを選択してください。';
      if (this.uploadData.outboundCallList.length <= 0) return messageContent.requireMinRegister('登録番号', 1);
      if (this.uploadData.outboundCallList.length > 1000) return messageContent.requireMaxRegister('登録番号', 1000);
      let lineNo = 1;
      for (const data of this.uploadData.outboundCallList) {
        // 架電番号がNull
        if (!data.phone) return messageContent.callDestinationLineXXRequired(lineNo);
        // 特殊文字チェック・電話番号形チェック
        if (data.phone[0] !== '0' || this.hasSpecialCharacterInString(data.phone) || !this.isPhoneNumber(data.phone))
          return messageContent.callDestinationLineXXInvalid(lineNo);

        // 架電先名称がNull
        if (!data.name) return messageContent.callDestinationNameLineXXRequired(lineNo);
        // 架電先名称の特殊文字チェック
        if (this.hasSpecialCharacterInString(data.name))
          return messageContent.callDestinationNameLineXXIncludeSpecialCharacters(lineNo);
        //架電先名称の文字数オーバー200字以上
        if (data.name.length > 200) return messageContent.callDestinationNameLineXXLengthExceeded(lineNo);

        if (data.name.length > 200) return messageContent.requireStringSizeMax('架電先名称', 200);
        lineNo++;
      }

      return '';
    },
    clearInputCsvFile() {
      this.currentUploadFile.file = null;
      this.currentUploadFile.binary = null;
      this.currentUploadFile.size = 0;
      this.currentUploadFile.name = '';
      this.uploadData.outboundCallList = [];
    },
    validateUploadCsvData() {
      // ファイル未選択
      if (this.hasSpecialCharacterInObject(this.uploadData)) return messageContent.hasSpecialCharacter;
      if (!this.uploadData.listName) return messageContent.requireInput('リスト名');
      if (!this.numberOnly(this.uploadData.repeatLimit)) return messageContent.requireInputFormat('繰り返');
      if (this.uploadData.repeatLimit <= 0) return messageContent.requireMinRegister('繰り返', 1);
      if (this.uploadData.repeatLimit > 3) return messageContent.requireMaxRegister('繰り返', 3);
      if (this.uploadData.outboundCallList.length <= 0) return messageContent.csvUploadFileRequired;
      if (!this.uploadData.phone || this.uploadData.phone === UNSELECTED)
        return messageContent.requireChoice('発信番号');
      return '';
    },
    handleCloseUploadResult() {
      this.uploadResultModalVisible = false;
    },
    clearUploadData() {
      this.uploadData = {
        id: '',
        listName: '',
        repeatLimit: 1,
        phone: this.phoneList[0].value,
        outboundCallList: [],
      };
    },
    handleShowUploadResultModal(result, total) {
      if (result) {
        this.uploadResultContent = result;
      } else {
        this.uploadResultContent = `${total}件 登録されました`;
      }
      this.uploadResultModalVisible = true;
    },
    handleUpdateOutboundListStatus(id, status) {
      return this.postRequest('/outbound/updateOutboundCallListStatus', { id, status })
        .then(e => {
          if (e.status === 'success') {
            return '';
          } else if (e.status === 'updateInfoInvalid') {
            return e.status;
          }
          return 'failed';
        })
        .catch(e => {
          return 'failed';
        });
    },
    handleGetCallLogDetails(callSid) {
      return this.postRequest('/callLogClient/getCallLogDetail', { callSid })
        .then(e => {
          if (e.status === 'success') {
            return e.data;
          }
          return [];
        })
        .catch(e => {
          return [];
        });
    },
    handleFetchAvailableTelNumbers() {
      return this.postRequest('/home/fetchAvailableTelNumbers')
        .then(res => {
          if (res.status === 'success') {
            const telNumbers = res.telNumbers;
            const telNumberListOptions = [{ label: '発信元番号選択', value: UNSELECTED }];
            //let isSelectedNumberValid = false;
            for (const telNumber in telNumbers) {
              const label = telNumbers[telNumber] || '未設定';
              telNumberListOptions.push({ label: `${label}（${telNumber}）`, value: telNumber });
            }
            this.phoneList = telNumberListOptions;
            this.uploadData.phone = UNSELECTED;
          } else {
            this.phoneList = [{ label: '発信元番号選択', value: UNSELECTED }];
            throw new Error('Fetch data failed');
          }
        })
        .catch(err => {
          this.showErrorModal(messageContent.requireTry('発信元番号取得'));
        });
    },
    showNotifyAllNumberAreLocked() {
      this.notifyAllNumberAreLockedModalVisible = true;
    },
    closeNoifyAllNumberLockedModal() {
      this.notifyAllNumberAreLockedModalVisible = false;
    },
    fetchCompanyIDListHandler: async function () {
      await this.postRequest('/companymgmt/getcompanyidlistCCCOnly', { withPoint: true })
        .then(e => {
          this.companyIDList = e.data;
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('登録ユーザーの取得'));
        });
    },
    handleUnlockAllPhoneNumber(row) {
      this.postRequest('/outbound/unlockAllCall', { id: row.id, companyID: this.selectedCompanyID || this.companyID })
        .then(data => {
          if (data.status === 'success') {
            this.showInfoModal(messageContent.notifyAllPhoneUnlocked);
          } else if (data.status === 'updateInfoInvalid') {
            this.showErrorModal(messageContent.notifyOutboundDataHasChanged);
          } else {
            throw new Error(data.status);
          }
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('ロック解除'));
        });
    },
  },
};
</script>
